module.exports = __webpack_public_path__ + "img/ic_barrierfree.370597aa.svg";